import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";
import { Check, Lock } from "lucide-react";

export default function BookingConfirmation() {
  const { id } = useParams();
  const [b, setB] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/bookings/${id}`);
        setB(data);
        // Commit B — §3.4. `booking.confirmation_view` fires on
        // successful load — tags the provider so the dashboard's
        // Pluckonomics module can attribute the completed booking.
        trackEvent("booking.confirmation_view", {
          provider_id: data?.provider_id || null,
        });
      } catch {
        // ignore
      }
    })();
  }, [id]);

  return (
    <div className="bg-background">
      <main className="mx-auto max-w-2xl px-6 py-16 text-center" data-testid="booking-confirmation">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-orange text-white">
          <Check className="h-10 w-10" />
        </div>
        <h1 className="mt-6 font-heading text-4xl font-bold text-pp-text sm:text-5xl">
          You&apos;re booked!
        </h1>
        {b && (
          <Card className="mt-8 rounded-3xl border-border bg-pp-surface p-6 text-left shadow-none">
            <p className="text-sm text-muted-foreground">
              Date: <b className="text-pp-text">{b.service_date}</b> · {b.preferred_window.start}–{b.preferred_window.end}
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              Dogs: <b className="text-pp-text">{b.dog_count}</b>
              {b.unsecured_count > 0 && (
                <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-brand-slate px-2 py-0.5 text-xs text-brand-orange">
                  <Lock className="h-3 w-3" /> Securement applies
                </span>
              )}
            </p>
            <p className="mt-3 font-heading text-2xl font-bold text-brand-orange">
              Total paid: ${b.pricing_snapshot.total.toFixed(2)} <span className="text-xs font-normal text-muted-foreground">(mocked)</span>
            </p>
            <p
              className="mt-2 text-[11px] leading-snug text-muted-foreground"
              data-testid="booking-confirmation-fee-footer"
            >
              Payment processing included. No surprise fees.
            </p>
          </Card>
        )}
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/dashboard/customer">
            <Button className="rounded-full bg-pp-orange text-pp-cta-text hover:bg-pp-orange-hover">
              View in dashboard
            </Button>
          </Link>
          <Link to="/book">
            <Button variant="ghost" className="rounded-full">Book another</Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
